module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-36.45b94578.png";